import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toggleExploreAside, toggleFilterAside, toggleRightAside } from 'actions/ui';
import './asideRight.css';
import ExploreMenu from 'components/asideRight/components/exploreMenu';
import AdminMenu from './components/adminMenu';
import FilterMenu from './components/filterMenu';
import { ReactHelpers } from '@salesperformanceint/e4shared';

export const AsideRight = ({ sideStyle }) => {
    const dispatch = useDispatch();

    const [clickEvent, setClickEvent] = React.useState({});
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const aside = React.useRef(null);
    const { rightAsideOpen, exploreAsideOpen, filterAsideOpen } = useSelector(state => state.ui);
    const asideOpen = rightAsideOpen || exploreAsideOpen || filterAsideOpen;

    React.useEffect(() => {
        if (aside.current) {
            if (
                rightAsideOpen &&
                !aside.current.contains(clickEvent.target) &&
                clickEvent.target?.id !== 'toggle-right-button' &&
                clickEvent.target?.id !== 'toggle-right-button-icon' &&
                clickEvent.target?.tagName !== 'HTML'
            ) {
                dispatch(toggleRightAside());
            }

            // there can be multiple modals in play so we need to go through them all
            const modals = document.getElementsByClassName('modal show');

            if (
                exploreAsideOpen &&
                !aside.current.contains(clickEvent.target) &&
                !Array.from(modals).some(modal => modal.contains(clickEvent.target)) &&
                clickEvent.target?.id !== 'behaviour-search-button' &&
                clickEvent.target?.id !== 'modal-button-close' &&
                clickEvent.target?.tagName !== 'HTML'
            ) {
                dispatch(toggleExploreAside());
            }

            if (
                filterAsideOpen &&
                !aside.current.contains(clickEvent.target) &&
                clickEvent.target?.id !== 'search-filter-button' &&
                clickEvent.target?.id !== 'search-filter-button-icon' &&
                clickEvent.target?.id !== 'modal-button-close' &&
                clickEvent.target?.tagName !== 'HTML'
            ) {
                dispatch(toggleFilterAside());
            }
        }
    }, [aside.current, clickEvent, rightAsideOpen, exploreAsideOpen, filterAsideOpen]);

    React.useEffect(() => {
        ReactHelpers.setModalOpen(filterAsideOpen);
    }, [filterAsideOpen]);

    React.useEffect(() => {
        const keyUp = e => {
            if (e.key === 'Enter') setClickEvent(e);
            if (e.key === 'Escape') {
                dispatch(toggleRightAside(null));
                dispatch(toggleExploreAside(null));
            }
        };

        const handleScroll = () => {
            const position = window.scrollY;
            setScrollPosition(position);
        };

        document.addEventListener('mousedown', setClickEvent, false);
        document.addEventListener('keydown', keyUp, false);
        window.addEventListener('scroll', handleScroll);

        return () => {
            document.removeEventListener('mousedown', setClickEvent, false);
            document.removeEventListener('keydown', keyUp, false);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <aside
            ref={aside}
            className={`control-sidebar control-sidebar-dark ${sideStyle} ${asideOpen ? 'control-sidebar-open' : ''}`}
        >
            {rightAsideOpen && <AdminMenu />}
            {exploreAsideOpen && <ExploreMenu scrollPosition={scrollPosition} />}
            {filterAsideOpen && <FilterMenu scrollPosition={scrollPosition} />}
        </aside>
    );
};

export default withRouter(AsideRight);
